import React,{useState,useEffect, useRef} from 'react'
import { useParams } from 'react-router';
import './Document.css';
import get_document from '../../context/action/document/get_document';
import Classic_template_1 from '../../component/document_template/Classic_template_1';
import Classic_template_2 from '../../component/document_template/Classic_template_2';
import Classic_template_3 from '../../component/document_template/Classic_template_3';
import Classic_template_4 from '../../component/document_template/Classic_template_4';
import Classic_template_5 from '../../component/document_template/Classic_template_5';
import Modern_template_1 from '../../component/document_template/Modern_template_1';
import Modern_template_3 from '../../component/document_template/Modern_template_3';
import Modern_template_4 from '../../component/document_template/Modern_template_4';
import Modern_template_5 from '../../component/document_template/Modern_template_5';
import Wave_template_1 from '../../component/document_template/Wave_template_1';
import Wave_template_2 from '../../component/document_template/Wave_template_2';
import Wave_template_3 from '../../component/document_template/Wave_template_3';
import Wave_template_4 from '../../component/document_template/Wave_template_4';
import Wave_template_5 from '../../component/document_template/Wave_template_5';
import Modern_template_2 from '../../component/document_template/Modern_template_2';
import { FaCopy } from "react-icons/fa";
import { GiPayMoney } from "react-icons/gi";
import { FaDownload } from "react-icons/fa";
import de from '../../utils/language_de';
import en from '../../utils/language_en';
import es from '../../utils/language_es';
import fr from '../../utils/language_fr';
import it from '../../utils/language_it';
import pt from '../../utils/language_pt';
import zh from '../../utils/language_zh';
import { usePDF } from 'react-to-pdf';
import { PDFDownloadLink } from "@react-pdf/renderer";
import Classic_template_1_PDF from '../../component/document_pdf/Classic_template_1_pdf';
import Classic_template_2_PDF from '../../component/document_pdf/Classic_template_2_pdf';
import Classic_template_3_PDF from '../../component/document_pdf/Classic_template_3_pdf';
import Classic_template_4_PDF from '../../component/document_pdf/Classic_template_4_pdf';
import Classic_template_5_PDF from '../../component/document_pdf/Classic_template_5_pdf';
import Modern_template_1_PDF from '../../component/document_pdf/Modern_template_1_pdf';
import Modern_template_2_pdf from '../../component/document_pdf/Modern_template_2_pdf';
import Modern_template_3_PDF from '../../component/document_pdf/Modern_template_3_pdf';
import Modern_template_4_PDF from '../../component/document_pdf/Modern_template_4_pdf';
import Modern_template_5_PDF from '../../component/document_pdf/Modern_template_5_pdf';
import Wave_template_3_PDF from '../../component/document_pdf/Wave_template_3_pdf';
import Wave_template_4_PDF from '../../component/document_pdf/Wave_template_4_pdf';
import Wave_template_5_PDF from '../../component/document_pdf/Wave_template_5_pdf';
import Wave_template_2_PDF from '../../component/document_pdf/Wave_template_2_pdf';
import Wave_template_1_pdf from '../../component/document_pdf/Wave_template_1_pdf';
import send_notification from '../../context/action/document/send_notification';

const Document = () => {
  const { document_id } = useParams();
  const [isLoading,setisLoading]=useState(true);
  const [notFound,setnotFound]=useState(false);
  const [data,setData]=useState([]);
  const [selected_template,setselected_template]=useState('');
  const [copiedKey,setCopiedKey]=useState('');
  const template_ref=useRef(null);
  const d = data[0] || {};
  const localizationn=d?.localization=="zh"?zh:d?.localization=="de"?de:d?.localization=="en"?en:d?.localization=="es"?es:d?.localization=="fr"?fr:d?.localization=="it"?it:d?.localization=="pt"?pt:en;
//   const { toPDF, targetRef } = usePDF({filename: `${d?.document_number}.pdf`});

  const send_seen_notification=async(document)=>{
    if(document?.notification_seen_state=="false"){
      var locc=document?.localization=="zh"?zh:document?.localization=="de"?de:document?.localization=="en"?en:document?.localization=="es"?es:document?.localization=="fr"?fr:document?.localization=="it"?it:document?.localization=="pt"?pt:en;
      var doc_type=document?.document_type;
      var doc_number=document?.document_number;
      var doc_id=document?.document_id;
      var user_notification_token=document?.user_notification_token;
      var notification_type="notification_seen_state";
      var cli_name=JSON.parse(document?.client_detail)?.client_name;
      var notification_body;
      if(doc_type=="invoice"){
        notification_body=locc?.client_name_viewed_your_invoice_document_number.replace('{client_name}', cli_name).replace('{document_number}', doc_number);
      }else{
        notification_body=locc?.client_name_viewed_your_estimate_document_number.replace('{client_name}', cli_name).replace('{document_number}', doc_number);
      }
      if (user_notification_token && user_notification_token.trim().length > 6){
        send_notification(doc_id,user_notification_token,"SnapBill","",notification_body,notification_type).then((res)=>{
          // console.log(res);
        }).catch((err)=>{
          // console.log(err);
        });
      }
      
    }
  }

  const send_payment_notification=async(document,payment_method)=>{
    if(document?.notification_payment_state=="false"&&document?.document_type=="invoice"){
      var locc=document?.localization=="zh"?zh:document?.localization=="de"?de:document?.localization=="en"?en:document?.localization=="es"?es:document?.localization=="fr"?fr:document?.localization=="it"?it:document?.localization=="pt"?pt:en;
      var doc_type=document?.document_type;
      var doc_number=document?.document_number;
      var doc_id=document?.document_id;
      var user_notification_token=document?.user_notification_token;
      var notification_type="notification_payment_state";
      var cli_name=JSON.parse(document?.client_detail)?.client_name;
      var notification_subtitle=locc?.good_news;
      var notification_body=locc?.client_name_started_paying_invoice.replace('{client_name}', cli_name).replace('{document_number}', doc_number).replace('{payment_method}', payment_method);
      if (user_notification_token && user_notification_token.trim().length > 6){
        send_notification(doc_id,user_notification_token,"SnapBill",notification_subtitle,notification_body,notification_type).then((res)=>{
          // console.log(res);
        }).catch((err)=>{
          // console.log(err);
        });
      }
      
    }
  }

  const handleCopy = (value,key) => {
    if(!value) return;
    navigator.clipboard.writeText(value).then(()=>{
      setCopiedKey(key);
      setTimeout(()=>setCopiedKey(''),1500);
    });
  };

  const handlePay_Paypal = (paypal_email, total_document_amount, document_currency) => {
    const business = String(paypal_email || '').trim();
    const amount = Number(total_document_amount);
    let currency = document_currency;
    if (typeof document_currency === 'string') {
      if (document_currency.startsWith('{')) {
        currency = JSON.parse(document_currency)?.code;
      } else {
        currency = document_currency;
      }
    } else if (document_currency && typeof document_currency === 'object') {
      currency = document_currency?.code;
    }
    if (!business || !amount || !currency) return;
    const formattedAmount = amount.toFixed(2);
    const params = new URLSearchParams({
      cmd: '_xclick',
      business: business,
      amount: formattedAmount,
      currency_code: String(currency).toUpperCase(),
      no_note: '1',
      no_shipping: '1'
    });
    const url = `https://www.paypal.com/cgi-bin/webscr?${params.toString()}`;
    send_payment_notification(d,"PayPal");
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handlePay_Stripe=(stripe_email)=>{
    const stripe_invoice_link = String(stripe_email || '').trim();
    if(!stripe_invoice_link){
      alert(localizationn?.invalid_stripe_invoice_link);
      return;
    }
    let u;
    try{
      u = new URL(stripe_invoice_link);
    }catch(e){
      alert(localizationn?.invalid_stripe_invoice_link);
      return;
    }
    const isHttps = u.protocol === 'https:';
    const host = u.hostname.toLowerCase();
    const path = u.pathname.toLowerCase();
    const isStripeDomain = host.endsWith('stripe.com');
    const hasInvoicePath = path.includes('/invoice') || path.startsWith('/i/');
    if(!isHttps || !isStripeDomain || !hasInvoicePath){
      alert(localizationn?.invalid_stripe_invoice_link);
      return;
    }
    send_payment_notification(d,"Stripe");
    window.open(stripe_invoice_link,'_blank','noopener,noreferrer');
  }

  const hasFetched = useRef(false);

  useEffect(()=>{
    if (hasFetched.current) return;
    hasFetched.current = true;
    
    get_document(document_id).then((res)=>{
        if(res?.status!='ok'||res?.data.length<=0){
            setnotFound(true);
        }else{
            setnotFound(false);
            setselected_template(JSON.parse(res?.data[0]?.template)?.id);
            setData(res.data);
            setTimeout(() => {
              send_seen_notification(res.data[0]);
            }, 800);
        }

        setisLoading(false);
    }).catch(err=>{
        setnotFound(true);
        setisLoading(false);
    });

  },[document_id]);

  if(isLoading){
      return (
          <div className="loading-container">
              <div className="spinner"></div>
              <p className="loading-text">Loading data...</p>
          </div>
      )
  }

  if(notFound){
      return (
          <div className="not-found-container">
              <div className="not-found-content">
                  <i className="not-found-icon">❌</i>
                  <h1 className="not-found-title">Document Not Found</h1>
                  <p className="not-found-message">The Document you're looking for could not be found.</p>
                  <button onClick={() => window.history.back()} className="back-button">
                      Go Back
                  </button>
              </div>
          </div>
      )
  }

  return (
    <div className='min-h-screen flex flex-col items-center justify-center' style={{backgroundColor:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#f3f4f6':'#222222'}}>
        {(d?.paypal_state=="true"||d?.stripe_state=="true"||d?.payment_instruction_state=="true")&&(
        <div className='w-11/12 lg:w-6/12 mt-5'>
          <div className={`rounded-sm shadow-sm p-6`} style={{backgroundColor:JSON.parse(d?.template)?.selectedcolor?.primary || '#ffffff'}}>
            <div className='text-lg font-semibold' style={{color:JSON.parse(d?.template)?.selectedcolor?.textcolor || '#000000'}}>{localizationn?.payment_options}</div>
            <div className='mt-4 space-y-4'>
              {d?.paypal_state==="true" && (
                <div className='border border-gray-200 rounded-xl p-4 flex flex-col md:flex-row justify-between'>
                  <div>
                    <div className='text-base font-medium' style={{color:JSON.parse(d?.template)?.selectedcolor?.textcolor2 || '#000000'}}>PayPal</div>
                    <div className='text-sm' style={{color:JSON.parse(d?.template)?.selectedcolor?.textcolor || '#000000'}}>
                        {d?.paypal_email}
                    </div>
                  </div>
                  <div className='flex gap-2 mt-5 md:mt-0'>
                    <div>
                        <button
                            onClick={()=>{handlePay_Paypal(d?.paypal_email,d?.total_document_amount,d?.document_currency)}}
                            className='flex items-center gap-2 px-3 py-2 rounded-lg transition'
                            style={{color:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#000000':'#ffffff',
                                    backgroundColor:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#f3f4f6':'#222222',
                            }}
                        >
                            {localizationn?.pay_now}
                            <GiPayMoney />
                        </button>
                    </div>
                    <div>
                        <button
                            onClick={()=>handleCopy(d?.paypal_email,'paypal')}
                            className='flex items-center gap-2 px-3 py-2 rounded-lg transition'
                            style={{color:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#000000':'#ffffff',
                                    backgroundColor:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#f3f4f6':'#222222',
                            }}
                        >
                            {copiedKey==='paypal' ? localizationn?.copied : localizationn?.copy}
                            <FaCopy />
                        </button>
                    </div>
                  </div>
                </div>
              )}
              {d?.stripe_state==="true" && (
                <div className='border border-gray-200 rounded-xl p-4 flex flex-col md:flex-row justify-between'>
                  <div>
                    <div className='text-base font-medium' style={{color:JSON.parse(d?.template)?.selectedcolor?.textcolor2 || '#000000'}}>Stripe</div>
                    <div className='text-sm' style={{color:JSON.parse(d?.template)?.selectedcolor?.textcolor || '#000000'}}>{d?.stripe_email}</div>
                  </div>
                  <div className='flex gap-2 mt-5 md:mt-0'>
                    <div>
                        <button
                            onClick={()=>handlePay_Stripe(d?.stripe_email)}
                            className='flex items-center gap-2 px-3 py-2 rounded-lg transition'
                            style={{color:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#000000':'#ffffff',
                                    backgroundColor:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#f3f4f6':'#222222',
                            }}
                        >
                            {localizationn?.pay_now}
                            <GiPayMoney />
                        </button>
                    </div>
                    <div>
                        <button
                            onClick={()=>handleCopy(d?.stripe_email,'stripe')}
                            className='flex items-center gap-2 px-3 py-2 rounded-lg transition'
                            style={{color:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#000000':'#ffffff',
                                    backgroundColor:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#f3f4f6':'#222222',
                            }}
                        >
                            {copiedKey==='stripe' ? localizationn?.copied : localizationn?.copy}
                            <FaCopy />
                        </button>
                    </div>
                  </div>
                </div>
              )}

              {d?.payment_instruction_state==="true" && (
                <div className='min-h-32 border border-gray-200 rounded-xl p-4 flex flex-col md:flex-row justify-between'>
                  <div>
                    <div className='text-base font-medium' style={{color:JSON.parse(d?.template)?.selectedcolor?.textcolor2 || '#000000'}}>{localizationn?.payment_instructions}</div>
                    <div className='text-sm' style={{color:JSON.parse(d?.template)?.selectedcolor?.textcolor || '#000000'}}>{d?.payment_instruction}</div>
                  </div>
                  <div className='mt-5 md:mt-0'>
                    <button
                        onClick={()=>{
                          handleCopy(d?.payment_instruction,'payment_instruction');
                          send_payment_notification(d,localizationn?.payment_instructions);
                        }}
                        className='flex items-center gap-2 px-3 py-2 rounded-lg transition'
                        style={{color:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#000000':'#ffffff',
                                backgroundColor:(JSON.parse(d?.template)?.selectedcolor?.primary)==='#fff'?'#f3f4f6':'#222222',
                        }}
                    >
                        {copiedKey==='payment_instruction' ? localizationn?.copied : localizationn?.copy}
                        <FaCopy />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        )}
        <div className='w-11/12 lg:w-6/12 my-5'>
            <PDFDownloadLink 
              document={
                selected_template==='classic_1'?
                  <Classic_template_1_PDF {...data[0]} />:
                selected_template==='classic_2'?
                  <Classic_template_2_PDF {...data[0]} />:
                selected_template==='classic_3'?
                  <Classic_template_3_PDF {...data[0]} />:
                selected_template==='classic_4'?
                  <Classic_template_4_PDF {...data[0]} />:
                selected_template==='classic_5'?
                  <Classic_template_5_PDF {...data[0]} />:
                selected_template==='modern_1'?
                  <Modern_template_1_PDF {...data[0]} />:
                selected_template==='modern_2'?
                  <Modern_template_2_pdf {...data[0]} />:
                selected_template==='modern_3'?
                  <Modern_template_3_PDF {...data[0]} />:
                selected_template==='modern_4'?
                  <Modern_template_4_PDF {...data[0]} />:
                selected_template==='modern_5'?
                  <Modern_template_5_PDF {...data[0]} />:
                selected_template==='wave_1'?
                  <Wave_template_1_pdf {...data[0]} />:
                selected_template==='wave_2'?
                  <Wave_template_2_PDF {...data[0]} />:
                selected_template==='wave_3'?
                  <Wave_template_3_PDF {...data[0]} />:
                selected_template==='wave_4'?
                  <Wave_template_4_PDF {...data[0]} />:
                selected_template==='wave_5'?
                  <Wave_template_5_PDF {...data[0]} />:
                  null
              } 
              fileName={`${data[0]?.document_number}.pdf`}
              >
                {({ loading }) => (
                  <div className={`w-full h-14 rounded bg-[#1abc9c] flex items-center justify-center cursor-pointer ${loading ? 'opacity-60' : 'hover:opacity-90'}`}>
                    {loading ? (
                      <div className="flex items-center gap-3 text-white">
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        <span className="font-medium">Preparing document...</span>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 text-white font-medium">
                        <FaDownload />
                        <span>Download PDF</span>
                      </div>
                    )}
                  </div>
                )}
            </PDFDownloadLink>
        </div>
        <div className='w-11/12 lg:w-6/12 mb-10' 
            // ref={targetRef} 
            style={{backgroundColor:'blue'}}>
        {selected_template==='classic_1'?
            <Classic_template_1 {...data[0]} />:
         selected_template==='classic_2'?
            <Classic_template_2 {...data[0]} />:
         selected_template==='classic_3'?
            <Classic_template_3 {...data[0]} />:
         selected_template==='classic_4'?
            <Classic_template_4 {...data[0]} />:
         selected_template==='classic_5'?
            <Classic_template_5 {...data[0]} />:
         selected_template==='modern_1'?
            <Modern_template_1 {...data[0]} />:
         selected_template==='modern_2'?
            <Modern_template_2 {...data[0]} />:
         selected_template==='modern_3'?
            <Modern_template_3 {...data[0]} />:
         selected_template==='modern_4'?
            <Modern_template_4 {...data[0]} />:
         selected_template==='modern_5'?
            <Modern_template_5 {...data[0]} />:
         selected_template==='wave_1'?
            <Wave_template_1 {...data[0]} />:
         selected_template==='wave_2'?
            <Wave_template_2 {...data[0]} />:
         selected_template==='wave_3'?
            <Wave_template_3 {...data[0]} />:
         selected_template==='wave_4'?
            <Wave_template_4 {...data[0]} />:
         selected_template==='wave_5'?
            <Wave_template_5 {...data[0]} />:
            null
        }            
        </div>
    </div>
  )
}

export default Document
